import { render, staticRenderFns } from "./ReportsMenue.vue?vue&type=template&id=225bd3a3&scoped=true"
import script from "./ReportsMenue.vue?vue&type=script&lang=js"
export * from "./ReportsMenue.vue?vue&type=script&lang=js"
import style0 from "./ReportsMenue.vue?vue&type=style&index=0&id=225bd3a3&prod&scoped=true&lang=css"
import style1 from "./ReportsMenue.vue?vue&type=style&index=1&id=225bd3a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225bd3a3",
  null
  
)

export default component.exports